import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useNotificationStore } from '@/stores/helpers/notification.js'
import OrderDocumentService from '@/services/admin/OrderDocumentService.js'
import i18n from '@/i18n/i18n.js'
import { errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const allowedSorts = 'created_at'
export const allowedAppends = 'document_verification_activity,mime_type'

export const useOrderDocumentStore = defineStore('adminOrderDocument', () => {
  // #region - Pinia State
  const document = ref(null)
  const previousDocuments = ref([])

  const notificationStore = useNotificationStore()

  // #region - Pinia Helpers
  const sendNotification = (type, message) => {
    notificationStore.add({ type, message })
  }

  // #region - Pinia Actions
  const getDocument = async params => {
    try {
      const response = await OrderDocumentService.getDocument(params.orderId, params.documentId)
      document.value = response.data
      return response.data
    } catch (err) {
      sendNotification('danger', errorMessage(err))
      throw err
    }
  }

  const viewDocument = async documentId => {
    try {
      const response = await OrderDocumentService.viewDocument(documentId)
      return response
    } catch (err) {
      sendNotification('danger', errorMessage(err))
      throw err
    }
  }

  const fetchPreviousDocuments = async params => {
    try {
      const response = await OrderDocumentService.previousDocuments(params.orderId, params.documentId)
      previousDocuments.value = response.data
      return response.data
    } catch (err) {
      sendNotification('danger', errorMessage(err))
      throw err
    }
  }

  const updateDocumentStatus = async params => {
    try {
      const response = await OrderDocumentService.updateDocumentStatus(params.orderId, params.documentId, params.data)
      sendNotification('success', t('store.admin.order.update_order_document_status_success'))
      return response.data
    } catch (err) {
      sendNotification('danger', errorMessage(err))
      throw err
    }
  }

  const setDocument = doc => {
    document.value = doc
  }

  return {
    document,
    previousDocuments,
    getDocument,
    viewDocument,
    fetchPreviousDocuments,
    updateDocumentStatus,
    setDocument
  }
})
